module.exports = __webpack_public_path__ + "img/img73.e276c43d.svg";